import React, { useState ,useEffect} from "react";
import Pic from "./burger.jpg";
import { Link, useNavigate } from "react-router-dom";
import RedirectCommonModal from "../../components/alert/RedirectCommonModal";
import { fetch_all_propmotions } from "../../actions/promotions/promotion";
import { formatPromotionDate } from "../../utils/util";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import CheckOutSuccess from "../../components/alert/CheckOutSuccess";

function PromotionCard(props) {
  const { data, page, alertMsg, menuVisibility, isFuture ,startDate} = props;
  const hotelId = localStorage.getItem("hotel-id");
  const reservationData = JSON.parse(localStorage.getItem("guestDetailsArray"));
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility
  const [modalContent, setModalContent] = useState(null); // Modal content data
  const [chechOutLocalStorage, setchechOutLocalStorage] = useState(false);
  const [checkoutModal,setCheckoutModal] = useState(false);
  const cardBg = (source) => {
    switch (source) {
      case "restaurant":
        return "#D5DEE7";
      case "spa":
        return "#ABCFFF";
      case "event":
        return "#9EFFF4";
      default:
        return "#FFF";
    }
  };

  const mapObj = (obj, redirect, promotionId) => {
    switch (redirect) {
      case "restaurant":
        return {
          id: obj?.id,
          restaurant_name: obj?.restaurant_name,
          description: obj?.description,
          cuisine: obj?.cuisine,
          start_time: obj?.start_time,
          close_time: obj?.close_time,
          open_kitchen: obj?.kitchen_status,
          image: obj?.image,
          contactNumber: obj?.contact_number,
          promotionId,
        };
      case "spa":
        return {
          id: obj?.id,
          name: obj?.spa_name,
          description: obj?.description,
          image: obj?.image,
          offer: obj?.offer,
          contactNumber: obj?.contact_number,
          promotionId,
        };
      case "event":
        return { promotionId: promotionId };
      default:
        return null;
    }
  };

  const openModal = () => {
    setModalContent({
      title: data?.title,
      description: data?.description || "No additional details.",
      image: data?.image || Pic,
    });
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const linkvalue = (source, redirectData, itemData) => {
    switch (source) {
      case "restaurant":
        return (
          "../food-items/" + redirectData?.hotel_id + "-" + redirectData?.id + "-ItemId-" + itemData?.id
        );
      case "spa":
        return "../spa-catagory/" + redirectData?.hotel_id + "-" + redirectData?.id + "-SpaId-" + itemData?.id + "-SpaRate-" + itemData?.rate;
      case "event":
        return "../event/" + redirectData?.hotel_id + "-EventId-" + redirectData?.id ;
    }
  };

  const navigatePromo = ()=>{
    const url = linkvalue(data?.redirect, data?.redirectData, data?.itemData);
    const state = mapObj(data?.redirectData, data?.redirect, data?.id);
     console.log(data?.redirect,menuVisibility)
     if(menuVisibility?.IsSpa == 0 && data?.redirect == "spa"){ 
      alertMsg("Spa feature is not availble right now")
     }else if(menuVisibility?.IsIndoorDining == 0 && data?.redirect == "restaurant"){ 
      alertMsg("In room dining is not availble right now")
     }
     else if(menuVisibility?.IsEvent == 0 && data?.redirect == "event"){ 
      alertMsg("Event booking is not availble right now")
     }
    //  else if(!reservationData?.checkedIn && data?.redirect == "spa"){
    //    alertMsg("You can book spa after check-in")
    // }
    else{  
       navigate(url, { state });  
       //for adding the view count where admin can view howmany user view through promotion
       viewCount(); 
    }

  }

  async function viewCount() {

    try {
      const response = await axios.post(
        `${baseURL}/api/promotions`,
        {
            hotelId: data?.redirectData?.hotel_id,
            id:data?.id
        },
        {
          headers: {
            Accept: "application/json",
          }
        }
      );

      if (response) {
        console.log("yes")
      }
    } catch (error) {
      console.error("Error fetching data:", error);
     
    }
    
  }
  const handleCloseConModal = () => {
    setCheckoutModal(false);
  }
  
  useEffect(() => { 
    const checkoutValue = localStorage.getItem("checkout");
    if (checkoutValue == "true") {
      setchechOutLocalStorage(true);
    } else {
      setchechOutLocalStorage(false);
    }
  }, []);
  return (
    <>
      <div
         onClick={() => {
          if (isFuture) {
            openModal(); 
          } else if (chechOutLocalStorage){
            setCheckoutModal(true);
          }else{
            navigatePromo(); 
          }
        }}
        className="promo-card"
        style={{ background: cardBg(data?.redirect), width: page && "100%" }}
      >
        <div
          className="image-section"
          style={{ background: `url('${data?.image || Pic}')` }}
        ></div>
        <div className="flex flex-col gap-2">
          <div className="offer-name w-[100px] truncate">
            {data?.discount ? `${data?.discount}% Off` : data?.title}
          </div>
          <div className="offer-description max-w-[45%] truncate">
            {data?.discount ? data?.title : data?.description}
          </div>
          <button>Order Now</button>
        </div>
      </div>

      {isModalOpen && (
   <RedirectCommonModal para={`The promotion will be available from ${formatPromotionDate(startDate)} `}   hide={()=>{setIsModalOpen(false)}}/>

      )}
     
          <CheckOutSuccess
          isOpen={checkoutModal}
          onClose={handleCloseConModal}
          heading="You are currently in the checkout process and cannot request additional services at this time.!"
        />       
    </>
  );
}

export default PromotionCard;
